import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { ReportSectionForms } from './constants';
export function getActiveTypeFormData(payload, formType) {
    return payload && payload.activeTypes && payload.activeTypes.find((form)=>form.formId === ReportSectionForms[formType]);
}
export function isActive(payload, formType) {
    return payload && payload.activeTypes && payload.activeTypes.find((form)=>form.formId === ReportSectionForms[formType]);
}
export function getActiveTypeFormMap(payload) {
    var _payload_activeTypes;
    const types = {};
    // change from {"warez": 1} to {1: "warez"}
    const ReportSectionFormsFlipped = Object.entries(ReportSectionForms).reduce((obj, [key, value])=>_object_spread_props(_object_spread({}, obj), {
            [value]: key
        }), {});
    (_payload_activeTypes = payload.activeTypes) === null || _payload_activeTypes === void 0 ? void 0 : _payload_activeTypes.forEach((form)=>{
        if (form.formId) {
            types[ReportSectionFormsFlipped[form.formId]] = true;
        }
    });
    return types;
}

//# sourceMappingURL=helpers.js.map